module.exports = __webpack_public_path__ + "img/10.77b2bf42.jpg";